"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDatePicker = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
// TODO this package hasn't been updated in a while. Consider changing for a more maintained one
const react_datepicker_1 = __importStar(require("react-datepicker"));
const react_i18next_1 = require("react-i18next");
const fr_1 = require("date-fns/locale/fr");
const en_CA_1 = require("date-fns/locale/en-CA");
require("react-datepicker/dist/react-datepicker.css");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputDatePicker = (props) => {
    const maxDate = surveyHelper.parse(props.widgetConfig.maxDate, props.interview, props.path, props.user);
    const minDate = surveyHelper.parse(props.widgetConfig.minDate, props.interview, props.path, props.user);
    if (props.widgetConfig.locale &&
        (props.widgetConfig.locale[props.i18n.language] === 'fr' ||
            props.widgetConfig.locale[props.i18n.language] === 'en-CA')) {
        (0, react_datepicker_1.registerLocale)('fr', fr_1.fr);
        (0, react_datepicker_1.registerLocale)('en-CA', en_CA_1.enCA);
    }
    return (react_1.default.createElement("div", { className: "survey-question__input-date-picker-container" },
        react_1.default.createElement(react_datepicker_1.default, { autoComplete: "none", className: `apptr__form-input input-date-picker input-${props.widgetConfig.size || 'large'}`, name: props.id, id: props.id, ref: props.inputRef, showTimeSelect: props.widgetConfig.showTimeSelect ? true : false, dateFormat: props.widgetConfig.showTimeSelect ? 'dd/MM/yyyy h:mm aa' : 'dd/MM/yyyy', minDate: minDate ? minDate : undefined, maxDate: maxDate ? maxDate : undefined, locale: props.widgetConfig.locale && props.widgetConfig.locale[props.i18n.language]
                ? props.widgetConfig.locale[props.i18n.language]
                : undefined, placeholderText: props.widgetConfig.placeholderText
                ? surveyHelper.translateString(props.widgetConfig.placeholderText, props.i18n, props.interview, props.path)
                : props.t('main:ClickToSelectDate'), selected: props.value !== undefined ? new Date(props.value) : undefined, onChange: (date) => props.onValueChange({ target: { value: date } }) })));
};
exports.InputDatePicker = InputDatePicker;
exports.default = (0, react_i18next_1.withTranslation)()(exports.InputDatePicker);
//# sourceMappingURL=InputDatePicker.js.map